export default "/kiban/_next/static/images/searchButton-6abc36f744c2fc4cfbdbc3da226f327f.png";